{
  "fr": {
    "labels": {
      "true": "Oui",
      "false": "Non",
      "null": "nul",
      "supporter": {
        "badge": "Soutien",
        "tooltip": "Soutient FleetYards.net ce mois-ci"
      },
      "destroyedFleets": {
        "discarded": "Écartée",
        "purged": "Purgée"
      },
      "and": "et",
      "hide": "Masquer",
      "show": "Afficher",
      "only": "Uniquement",
      "description": "Description",
      "unavailable": "indisponible",
      "selected": "Sélectionné",
      "actions": "Actions",
      "status": "Statut",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "collapse": "Réduire",
      "price": "Prix",
      "expand": "Agrandir",
      "distance": "Distance",
      "anonymous": "Anonyme",
      "toggleNavigation": "Changer de navigation",
      "enableYoutube": "Cliquez pour activer les liens Youtube ou cliquez avec le bouton droit de la souris pour copier l'URL de la vidéo",
      "openInNewWindow": "Ouvrir en plein écran",
      "or": "ou",
      "deselect": "cliquer pour désélectionner",
      "networkStatusOffline": "statut du serveur : hors-ligne - service indisponible",
      "groups": "Groupes",
      "classifications": "Classifications",
      "features": {
        "stateOn": "Activé",
        "stateOff": "Désactivé",
        "stateConditional": "Conditionnel",
        "selfService": "Libre-service",
        "selfServiceEnabled": "Les utilisateurs peuvent activer/désactiver cette fonctionnalité",
        "selfServiceDisabled": "Les utilisateurs ne peuvent pas activer/désactiver cette fonctionnalité",
        "actors": "Acteurs",
        "groups": "Groupes",
        "noGroups": "Aucun groupe activé pour cette fonctionnalité.",
        "noActors": "Aucun acteur individuel activé pour cette fonctionnalité.",
        "user": "Utilisateur",
        "fleet": "Flotte",
        "actorType": "Type d'acteur",
        "percentageOfActors": "des acteurs",
        "percentageOfTime": "du temps",
        "currentState": "État actuel",
        "toggle": "Basculer",
        "settingsIntro": "Activez ou désactivez les fonctionnalités expérimentales pour votre compte. Ces fonctionnalités peuvent être incomplètes ou changer sans préavis.",
        "noFeaturesAvailable": "Aucune fonctionnalité libre-service n'est actuellement disponible.",
        "descriptions": {
          "tools_travel_times": "Afficher les temps de trajet estimés entre les emplacements.",
          "tools_cargo_grids": "Afficher la visionneuse interactive de grille de cargaison pour les vaisseaux.",
          "fleet_starmap": "Afficher la carte stellaire Star Citizen sur les pages des membres de flotte."
        },
        "registryHint": "Les flags sont déclarés dans config/feature_flags.yml et créés au déploiement. Vous contrôlez ici leurs conditions d'activation.",
        "fleetSettingsIntro": "Activez ou désactivez des fonctionnalités pour toute la flotte. Tous les membres voient ce que vous activez ici.",
        "fleetFeature": "Fonctionnalité de flotte",
        "fleetFeatureInfo": "L'activer ici ne l'active que pour vous. Les administrateurs de votre flotte peuvent l'activer pour toute la flotte.",
        "toggleForSelf": "Activer pour vous uniquement",
        "fleetFeatureGrantedShort": "Activé par la flotte",
        "fleetFeatureGranted": "Votre flotte l'a activé pour tous les membres, il ne peut donc pas être désactivé ici.",
        "groupFeatureGrantedShort": "Activé par le groupe",
        "groupFeatureGranted": "Un groupe dont vous faites partie a activé cette fonctionnalité, elle ne peut donc pas être désactivée ici.",
        "groupFeatureGrantedFleet": "Un groupe dont cette flotte fait partie a activé cette fonctionnalité, elle ne peut donc pas être désactivée ici.",
        "managedFeatureShort": "Géré",
        "managedFeature": "Cette fonctionnalité a été activée pour votre compte et ne peut pas être modifiée ici.",
        "managedFeatureFleet": "Cette fonctionnalité a été activée pour cette flotte et ne peut pas être modifiée ici.",
        "selfServiceUser": "Les utilisateurs peuvent basculer",
        "selfServiceFleet": "Les admins de flotte peuvent basculer"
      },
      "oauthApplication": {
        "name": "Nom de l'application",
        "clientId": "ID client",
        "clientSecret": "Secret client",
        "redirectUri": "URI de redirection",
        "redirectUriHint": "Utilisez une URI par ligne.",
        "confidential": "Confidentiel",
        "scopes": "Portées",
        "scopesHint": "Si aucune portée n'est sélectionnée, les portées par défaut seront utilisées : %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "Résolu",
        "unresolved": "Non résolu"
      },
      "imports": {
        "type": "Type",
        "status": "Statut",
        "version": "Version",
        "startedAt": "Démarré",
        "finishedAt": "Terminé",
        "failedAt": "Échec à",
        "info": "Info",
        "input": "Entrée",
        "output": "Sortie",
        "importData": "Données d'import",
        "file": "Fichier importé",
        "requestedBy": "Demandé par",
        "adminUser": "Administrateur",
        "user": "Utilisateur",
        "includeSystem": "Inclure le système",
        "systemRequester": "système",
        "statuses": {
          "created": "En file d'attente",
          "started": "En cours",
          "finished": "Terminé",
          "failed": "Échoué"
        }
      },
      "oauthApplications": {
        "settingsIntro": "Gérez vos applications OAuth. Ces applications peuvent accéder à l'API FleetYards au nom des utilisateurs.",
        "name": "Nom de l'application",
        "redirectUri": "URI de redirection",
        "confidential": "Confidentiel",
        "clientId": "ID client",
        "clientSecret": "Secret client",
        "scopes": "Portées",
        "defaultScopes": "Portées par défaut",
        "confidentialShort": "Confidentiel",
        "publicShort": "Public"
      },
      "fleetInviteToken": "invitation de la flotte",
      "scDataVersion": "Version corrigée",
      "lastReload": "Dernier rechargement",
      "createdAt": "Créé le",
      "updatedAt": "Mis à jour le",
      "addToHangar": "Ajouter au hangar",
      "home": {
        "search": "Recherche de vaisseaux"
      },
      "shop": {
        "rentalPrice": "prix de location",
        "sellPrice": "prix de vente",
        "buyPrice": "prix d'achat"
      },
      "shopCommodity": {
        "item": "Objets",
        "shop": "Magasin",
        "sellPrices": "Prix de vente",
        "buyPrices": "Prix d'achat",
        "rentalPrices": "Prix de location",
        "confirmed": "Confirmé ",
        "submittedBy": "Soumis par",
        "prices": {
          "label": "prix",
          "rentalPrice": "prix de location",
          "averageRentalPrice": "location (Ø)",
          "sellPrice": "prix de vente",
          "averageSellPrice": "vente pour (Ø)",
          "buyPrice": "Achats pour",
          "averageBuyPrice": "achats pour (Ø)",
          "rentalPrice1Day": "1 jour pour",
          "averageRentalPrice1Day": "1 jour pour (Ø)",
          "rentalPrice3Days": "3 jours pour",
          "averageRentalPrice3Days": "3 jours pour (Ø)",
          "rentalPrice7Days": "7 jours pour",
          "averageRentalPrice7Days": "7 jours pour (Ø)",
          "rentalPrice30Days": "30 jours pour",
          "averageRentalPrice30Days": "30 jours pour (Ø)"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Nouveaux vaisseaux en %{year}",
          "totalShips": "Nombre total de vaisseaux",
          "totalMembers": "Nombre total de membres",
          "vehicles": "Vaisseaux en hangar",
          "wishlists": "Vaisseaux en liste de souhaits",
          "shipOfTheMonth": "Vaisseau du mois"
        },
        "modelsByClassification": "Vaisseaux par catégorie",
        "modelsBySize": "Vaisseaux par taille",
        "vehiclesByModel": "Vaisseau par modèle (Top %{limit})",
        "modelsPerMonth": "Vaisseaux par mois",
        "modelsByManufacturer": "Vaisseaux par constructeur",
        "modelsByProductionStatus": "Vaisseau par état de production",
        "vehiclesPerMonth": "Vaisseaux en hangar par mois",
        "topVehiclesByModel": "Top 10 vaisseaux en hangar",
        "shipsOfTheMonth": "Vaisseau du mois",
        "crewDeficit": "Déficit d'équipage",
        "crewSurplus": "Excédent d'équipage",
        "membersByRole": "Membres par rôle",
        "csv": {
          "metric": "Métrique",
          "value": "Valeur",
          "count": "Nombre"
        }
      },
      "roadmap": {
        "selectWeek": "Sélectionnez une carte",
        "shipRoadmap": "Carte du vaisseau",
        "releases": "toutes les publications",
        "unscheduled": "Non planifiées",
        "lastUpdate": "Dernière mise à jour",
        "released": "publiée",
        "recentlyUpdated": "Mis à jour récemment",
        "committed": "enclenchée",
        "lastVersion": {
          "active": {
            "false": "Élément retiré de la feuille de route",
            "true": "Élément réajouté à la feuille de route",
            "decreased": "L'élément a été retiré de la roadmap",
            "increased": "L'élément a été rajouté à la roadmap"
          },
          "committed": "L'élément a été marqué comme engagé",
          "released": "L'élément a été publié dans le PU",
          "release": "Élément déplacé de la version %{old} à %{new}",
          "addedToRelease": "Nouvel élément dans la version %{release}"
        },
        "stories": {
          "one": "%{count} stocké",
          "other": "%{count} stockés"
        },
        "tasks": {
          "one": "de %{count} tâche",
          "other": "de %{count} tâches"
        },
        "ships": {
          "one": "%{count} vaisseau",
          "other": "%{count} Vaisseaux"
        }
      },
      "rsiRoadmap": "Carte RSI",
      "unknown": "inconnu",
      "none": "nul",
      "notAvailable": "N/A",
      "unknownModel": "%{slug} Inconnu",
      "not-available": "N/A",
      "receiveSaleNotifications": "",
      "publicUrl": "URL publique",
      "name": "Nom",
      "homepage": "Page principale",
      "discord": "Serveur Discord",
      "youtube": "Chaîne Youtube",
      "twitch": "Chaîne Twitch",
      "guilded": "Serveur Guilded",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "Filtre",
      "taxExcluded": "hors TVA",
      "hangar": "Hangar",
      "public": "Publique",
      "hangarStats": "Statistiques",
      "wishlist": "Liste de souhait",
      "fleetchart": "Graphique de la Flotte",
      "fleetchartApp": {
        "screenHeight": "Hauteur de l'écran",
        "viewpoint": "Point de vue",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Côté",
          "top": "Haut",
          "angled": "En biais",
          "front": "Face"
        },
        "gridSize": "%{size} mètre par zone de grille",
        "mode": "Mode",
        "modeOptions": {
          "classic": "Classique",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Statistiques",
      "hangarMetrics": {
        "total": "Total",
        "totalMoney": "Valeur de la monnaie",
        "totalCredits": "Crédits",
        "totalIngameValue": "Valeur aUEC du hangar",
        "totalMinCrew": "Équipage minimum",
        "totalMaxCrew": "Équipage maximum",
        "totalCargo": "Cargaison totale",
        "largestShip": "Plus grand vaisseau",
        "smallestShip": "Plus petit vaisseau",
        "averagePledgePrice": "Prix de Pledge moy.",
        "flightReady": "Prêt au vol",
        "uniqueModels": "Modèles uniques",
        "manufacturerCount": "Fabricants",
        "missingClassifications": "Rôles manquants",
        "wishlistTotalMoney": "Valeur de Pledge de la liste de souhaits",
        "wishlistTotalCredits": "Valeur en jeu de la liste de souhaits"
      },
      "selectModel": "Sélectionner un vaisseau",
      "findModel": "Trouver un vaisseau",
      "find": "Saisissez votre recherche",
      "selectUser": "Sélectionner un utilisateur",
      "findUser": "Tapez pour trouver un utilisateur",
      "selectAdminUser": "Sélectionner un administrateur",
      "selectFleet": "Sélectionner une flotte",
      "findFleet": "Tapez pour trouver une flotte",
      "compare": {
        "removeModel": "Enlever un vaisseau",
        "addModel": {
          "nullablePrompt": "Ajouter un vaisseau"
        },
        "enough": "Ne pensez-vous pas que 8 vaisseaux suffisent ? ;)",
        "toggleSection": "Afficher/Masquer %{section}",
        "shipCount": {
          "one": "%{count} vaisseau",
          "other": "%{count} vaisseaux"
        },
        "containersOfSize": "Conteneurs de %{size} SCU",
        "shieldGenerators": "Générateurs de boucliers",
        "armorHp": "HP du blindage",
        "fuelAndQuantum": "Carburant et Quantum",
        "weaponPoolSize": "Réserve d'énergie des armes",
        "crossSection": {
          "x": "Section transversale X",
          "y": "Section transversale Y",
          "z": "Section transversale Z"
        },
        "useAsBaseline": "Utiliser comme référence",
        "baseline": "Référence",
        "differencesOnly": "Différences uniquement",
        "compareToBaseline": "Comparer à la référence",
        "loadoutBySlot": "Équipement par emplacement",
        "slots": {
          "guns": "Canons principaux",
          "turrets": "Tourelles",
          "missiles": "Missiles",
          "shields": "Générateurs de boucliers",
          "powerPlants": "Réacteurs",
          "coolers": "Refroidisseurs",
          "quantumDrives": "Moteurs quantiques",
          "thrusters": "Propulseurs principaux",
          "countermeasures": "Contre-mesures"
        },
        "legend": {
          "best": "meilleur de la ligne",
          "worst": "pire",
          "share": "part du meilleur de la ligne",
          "better": "dépasse la référence",
          "worse": "en dessous"
        },
        "selectShips": "Sélectionner des vaisseaux"
      },
      "cargoRoutes": "Routes de cargaisons",
      "uecPerUnit": "aUEC / Unité",
      "au": "AU",
      "uec": "aUEC",
      "sell": "Vente",
      "buy": "Achat",
      "yourFlagship": "Votre vaisseau amiral",
      "flagship": "Vaisseau amiral",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flotte",
        "fid": "Identifiant de la Flotte",
        "name": "Nom",
        "logo": "Logo",
        "rsiSid": "SID",
        "description": "Description",
        "public": "Aperçu publique de la Flotte",
        "publicFleet": "Flotte publique",
        "publicStats": "Statistiques publiques",
        "publicFleetStats": "Statistiques de flotte publiques",
        "discord": {
          "url": "Serveur Discord",
          "hint": "Connectez un serveur Discord pour y refléter les événements sous forme d'événements planifiés natifs. Les membres peuvent répondre depuis Discord et l'inscription sera resynchronisée vers Fleetyards.",
          "guildId": "ID du serveur Discord",
          "channelId": "ID du salon vocal (facultatif)",
          "webhookUrl": "URL du webhook d'annonce (facultatif)",
          "installBotHint": "Ouvre la page d'installation Discord dans un nouvel onglet — choisissez le serveur vers lequel refléter les événements.",
          "statusOk": "Connecté à %{name}",
          "statusCodes": {
            "missing_token": "Le bot Fleetyards n'est pas configuré côté serveur. Contactez un administrateur.",
            "missing_guild": "Saisissez d'abord un ID de serveur Discord.",
            "invalid_token": "Le jeton du bot est invalide. Contactez un administrateur.",
            "bot_not_in_guild": "Le bot n'est pas présent sur ce serveur. Utilisez le lien d'installation pour l'ajouter.",
            "guild_not_found": "Discord ne reconnaît pas cet ID de serveur. Vérifiez la valeur.",
            "discord_error": "Discord a renvoyé une erreur inattendue.",
            "request_failed": "Impossible de joindre Fleetyards. Réessayez."
          }
        },
        "guilded": "Serveur Guilded",
        "homepage": "Page d'accueil",
        "twitch": "Chaîne Twitch",
        "youtube": "Chaîne Youtube",
        "backgroundImage": "Image de fond",
        "ts": "Serveur chat de l'équipe",
        "awaitingConfirmation": "En attente de confirmation par la Flotte",
        "members": {
          "primary": "Flotte principale?",
          "hideShips": "Cacher vos Vaisseaux pour cette Flotte ?",
          "shipsFilter": {
            "label": "Quels vaisseaux doivent être ajoutés à la Flotte ?",
            "nullablePrompt": "Aucune option sélectionnée",
            "field": "Sélection des vaisseaux",
            "values": {
              "all": "Tous les Vaisseaux",
              "hangar_group": "Tous les vaisseaux dans un Hangar de groupe donné",
              "hide": "Pas de Vaisseaux"
            }
          },
          "hangarGroupId": {
            "field": "Hangar de groupe",
            "label": "Spécifier un Hangar de groupe",
            "nullablePrompt": "Aucun Groupe sélectionné"
          },
          "total": "Total : %{count}",
          "joined": "Inscrit le",
          "invited": "Invité",
          "invitedAt": "Invité / Demandé le",
          "requested": "Demande d'adhésion requise",
          "declined": "Refusée",
          "pending": "Invitations et demandes en attente",
          "accepted": "Membres",
          "declinedMembers": "Refusé",
          "role": "Rôle",
          "roles": {
            "admin": "Admin",
            "officer": "Officier",
            "member": "Membre"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "Permanent",
          "privilegeGroups": {
            "fleet": "Flotte",
            "memberships": "Membres",
            "invites": "Invitations",
            "vehicles": "Véhicules",
            "roles": "Rôles",
            "inventories": "Inventaires",
            "missions": "Missions",
            "events": "Événements",
            "notifications": "Notifications"
          },
          "privileges": {
            "fleet:update": "Mettre à jour la flotte",
            "fleet:update:images": "Mettre à jour les images",
            "fleet:update:description": "Mettre à jour la description",
            "fleet:delete": "Supprimer la flotte",
            "fleet:manage": "Gérer la flotte",
            "fleet:memberships:read": "Voir les membres",
            "fleet:memberships:create": "Inviter des membres",
            "fleet:memberships:update": "Mettre à jour les membres",
            "fleet:memberships:delete": "Retirer des membres",
            "fleet:memberships:manage": "Gérer les membres",
            "fleet:invites:read": "Voir les invitations",
            "fleet:invites:create": "Créer des invitations",
            "fleet:invites:update": "Mettre à jour les invitations",
            "fleet:invites:delete": "Supprimer des invitations",
            "fleet:invites:manage": "Gérer les invitations",
            "fleet:vehicles:read": "Voir les véhicules",
            "fleet:vehicles:create": "Ajouter des véhicules",
            "fleet:vehicles:update": "Mettre à jour les véhicules",
            "fleet:vehicles:delete": "Retirer des véhicules",
            "fleet:vehicles:manage": "Gérer les véhicules",
            "fleet:roles:read": "Voir les rôles",
            "fleet:roles:create": "Créer des rôles",
            "fleet:roles:update": "Mettre à jour les rôles",
            "fleet:roles:delete": "Supprimer des rôles",
            "fleet:roles:manage": "Gérer les rôles",
            "fleet:inventories:read": "Voir les inventaires",
            "fleet:inventories:create": "Créer des inventaires",
            "fleet:inventories:update": "Mettre à jour les inventaires",
            "fleet:inventories:delete": "Supprimer des inventaires",
            "fleet:inventories:manage": "Gérer les inventaires",
            "fleet:missions:read": "Voir les missions",
            "fleet:missions:create": "Créer des missions",
            "fleet:missions:update": "Mettre à jour les missions",
            "fleet:missions:delete": "Supprimer des missions",
            "fleet:missions:manage": "Gérer les missions",
            "fleet:events:read": "Voir les événements",
            "fleet:events:create": "Créer des événements",
            "fleet:events:update": "Mettre à jour les événements",
            "fleet:events:delete": "Supprimer des événements",
            "fleet:events:manage": "Gérer les événements",
            "fleet:notifications:manage": "Gérer les paramètres de notification"
          },
          "name": "Nom",
          "rank": "Rang"
        },
        "inviteUrls": {
          "noLimit": "Pas de limite",
          "noExpiration": "N'expire jamais",
          "usesLeft": "%{count} de jours restants",
          "used": "Utilisé %{count} fois",
          "usedOfLimit": "%{count} sur %{limit} utilisés",
          "expiresIn": "Expire dans %{time}",
          "expired": "Expirée",
          "expiresAfterOptions": {
            "infinite": "Jamais",
            "30_minutes": "30 minutes",
            "1_hour": "1 heure",
            "6_hours": "6 heures",
            "12_hours": "12 heures",
            "1_day": "1 jour",
            "7_days": "7 jours"
          },
          "limitOptions": {
            "1": "1 utilisée",
            "5": "5 utilisées",
            "10": "10 utilisées",
            "25": "25 utilisées",
            "50": "50 utilisées",
            "100": "100 utilisées",
            "infinite": "Pas de limite"
          }
        },
        "calendarSubscription": {
          "intro": "Générez un lien privé que les membres peuvent utiliser pour s'abonner aux événements de cette flotte depuis leur application de calendrier (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Partagez le lien ci-dessus avec vos membres. Ils le collent dans leur application de calendrier (« S'abonner à un calendrier » ou « Ajouter par URL »). Le lien est privé — toute personne le possédant peut voir les événements de cette flotte."
        },
        "notifications": {
          "inAppHeading": "Notifications dans l'application",
          "inAppHint": "Choisissez quels changements du cycle de vie des événements apparaissent comme notifications dans l'application pour les membres de la flotte.",
          "events": {
            "fleet_event": {
              "published": "Événement publié",
              "locked": "Inscriptions verrouillées",
              "unlocked": "Inscriptions rouvertes",
              "starting_soon": "Événement imminent",
              "started": "Événement démarré",
              "completed": "Événement terminé",
              "cancelled": "Événement annulé",
              "archived": "Événement archivé",
              "destroyed": "Événement supprimé"
            },
            "fleet_event_signup": {
              "created": "Inscription ajoutée",
              "withdrawn": "Inscription retirée"
            }
          }
        },
        "inventories": {
          "name": "Nom",
          "description": "Description",
          "location": "Emplacement",
          "visibility": "Visibilité",
          "manager": "Gestionnaire",
          "itemsCount": "Entrées",
          "visibilities": {
            "members_only": "Membres uniquement",
            "officers_only": "Officiers uniquement"
          }
        }
      },
      "hangarGroup": {
        "name": "Nom",
        "color": "Couleur ",
        "sort": "Ordre de Tri",
        "public": "Afficher sur le hangar publique ?"
      },
      "source": "Source",
      "loadout": {
        "namePlaceholder": "Nom de la configuration...",
        "urlPlaceholder": "Coller l'URL de configuration erkul.games ou spviewer.eu...",
        "empty": "Aucune configuration pour le moment. Créez-en une pour commencer.",
        "active": "Active",
        "activate": "Définir comme active",
        "planOn": "Planifiez votre configuration sur"
      },
      "model": {
        "hidden": "Masqué ?",
        "active": "Actif ?",
        "inGame": "Dans le jeu ?",
        "adiMap": "Carte ADI ?",
        "ground": "Véhicule terrestre ?",
        "productionNote": "Note de production",
        "rsiId": "RSI ID",
        "length": "Longueur",
        "beam": "Largeur",
        "height": "Hauteur",
        "scKey": "SC Key",
        "price": "Prix",
        "pledgePrice": "Prix de Pledge",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Masse",
        "minCrew": "Équipage min.",
        "maxCrew": "Équipage max.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Vitesse max.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Cargaison",
        "cargoHolds": "Soutes à cargaison",
        "hydrogenFuelTankSize": "Taille du réservoir hydrogène",
        "hydrogenFuelTanks": "Réservoirs de carburant hydrogène",
        "quantumFuelTankSize": "Taille du réservoir Quantum",
        "quantumFuelTanks": "Réservoirs de carburant Quantum",
        "externalFuelTanks": "Réservoirs de carburant externes",
        "externalFuelTanksTotal": "Capacité totale",
        "externalFuelTanksCount": "Nacelles",
        "refuelBoom": "Perche de ravitaillement",
        "refuelBoomArm": "Bras",
        "refuelBoomNozzle": "Buse",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Lacet boosté",
        "pitchBoosted": "Tangage boosté",
        "rollBoosted": "Roulis boosté",
        "variants": "Variantes",
        "manufacturer": "Fabricant",
        "loaners": "Prêts",
        "paints": "Peintures",
        "modules": "Modules",
        "modulePackages": "Paquets de module",
        "upgrades": "Kits d'Amélioration",
        "brochure": "Brochure",
        "holo": "Holo",
        "angledView": "Vue angulaire",
        "angledViewColored": "Vue angulaire colorée",
        "sideView": "Vue de côté",
        "sideViewColored": "Vue de côté colorée",
        "frontView": "Vue de face",
        "frontViewColored": "Vue de face colorée",
        "topView": "Vue de dessus",
        "topViewColored": "Vue de dessus colorée",
        "onSale": "En Vente",
        "playerOwnable": "Possédable par un joueur ?",
        "salesPage": "Page des Ventes",
        "addons": "Kits de Modules et d'Amélioration",
        "storeImage": "Image du magasin",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Postes d'équipage",
        "needsCuration": "Nécessite une curation",
        "curatedPosition": "Poste curé manuellement",
        "baseModel": "Modèle de base",
        "fleetchartOffsetLength": "Décalage longueur du diagramme de flotte",
        "fleetchartOffsetBeam": "Décalage largeur du diagramme de flotte",
        "extendedLength": "Longueur étendue",
        "extendedBeam": "Largeur étendue",
        "extendedHeight": "Hauteur étendue",
        "extendedFleetchartOffsetLength": "Décalage longueur étendue du diagramme de flotte",
        "extendedFleetchartOffsetBeam": "Décalage largeur étendue du diagramme de flotte",
        "defaultHolo": "Holo par défaut",
        "extendedHolo": "Holo étendu",
        "extendedTopView": "Vue de dessus étendue",
        "extendedTopViewColored": "Vue de dessus étendue colorée",
        "extendedSideView": "Vue de côté étendue",
        "extendedSideViewColored": "Vue de côté étendue colorée",
        "extendedFrontView": "Vue de face étendue",
        "extendedFrontViewColored": "Vue de face étendue colorée",
        "extendedAngledView": "Vue en biais étendue",
        "extendedAngledViewColored": "Vue en biais étendue colorée",
        "state": {
          "retracted": "Replié",
          "extended": "Déployé"
        },
        "productionStatus": {
          "in-production": "En cours de production",
          "in-concept": "En concept",
          "ready": "Hangar prêt",
          "flight-ready": "Le vol est prêt",
          "announced": "Annoncée"
        },
        "scIdentifier": "SC Identifier"
      },
      "models": {
        "extraColumns": "Colonnes",
        "table": {
          "columns": {
            "storeImage": "Image",
            "storeImageWide": "Image large",
            "rsiStoreImage": "Image RSI",
            "rsiStoreImageWide": "Image RSI large",
            "angledView": "Image 3D",
            "angledViewWide": "Image 3D large",
            "rsiId": "RSI ID",
            "hidden": "Masqué",
            "active": "Actif",
            "createdAt": "Créé le",
            "updatedAt": "Mis à jour le",
            "manufacturerName": "Fabricant",
            "length": "Longueur",
            "beam": "Largeur",
            "height": "Hauteur",
            "mass": "Masse",
            "cargo": "Cargaison",
            "quantumFuelTankSize": "Carburant Quantum",
            "hydrogenFuelTankSize": "Carburant hydrogène",
            "minCrew": "Équipage",
            "maxCrew": "Équipage max.",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Vitesse max.",
            "groundMaxSpeed": "Vitesse au sol",
            "focus": "Spécialisation",
            "productionStatus": "Statut de production",
            "price": "Prix",
            "pledgePrice": "Prix de Pledge"
          }
        }
      },
      "metrics": {
        "info": "Information",
        "levels": "Niveaux",
        "views": "Vues",
        "base": "Base",
        "crew": "Équipe",
        "speed": "Vitesse",
        "cargo": "Cargaison",
        "combat": "Combat",
        "hardpoints": "Points d'attache",
        "missileOptions": "Options de Missile (si disponible)",
        "topView": "Vue de dessus"
      },
      "flight": {
        "title": "Vol",
        "scm": "croisière de combat",
        "nav": "croisière",
        "boost": "Boost",
        "boostSub": "postcombustion",
        "reverse": "Marche arrière",
        "maneuverability": "Maniabilité",
        "fuel": "Carburant",
        "fuelHydrogen": "Hydrogène",
        "fuelQuantum": "Quantum",
        "hint": "La maniabilité boostée dépend des pips alloués au moteur ; tout est à zéro lorsque le moteur n'est pas alimenté."
      },
      "base": {
        "price": "Prix",
        "priceInGame": "En jeu",
        "pricePledge": "Pledge",
        "availability": "Disponibilité"
      },
      "availability": {
        "title": "Disponibilité",
        "buy": "Achat",
        "rent": "Location",
        "cheapest": {
          "buy": "Achat le moins cher",
          "rent": "Location la moins chère"
        },
        "locations": {
          "one": "%{count} emplacement",
          "other": "%{count} emplacements"
        },
        "empty": "Aucun emplacement d'achat ou de location connu.",
        "timeRange": {
          "1-day": "1 jour",
          "3-days": "3 jours",
          "7-days": "7 jours",
          "30-days": "30 jours"
        }
      },
      "cargo": {
        "title": "Cargaison",
        "holdsSub": "réparties sur %{count} soutes",
        "maxContainerSub": "plus grande caisse acceptée",
        "containers": "Capacité en conteneurs",
        "hint": "Nombre maximal de conteneurs de chaque taille pouvant tenir sur les grilles de cargaison ; la barre indique la part de la capacité totale ainsi remplie."
      },
      "fuelTanks": {
        "capacitySub": "réparti sur %{count} nacelles",
        "podsSub": "supports externes",
        "components": "Types de nacelles",
        "perPod": "par nacelle",
        "hint": "Carburant transporté dans des nacelles montées sur des points d'attache externes ; la barre indique la part de chaque type dans la capacité totale."
      },
      "refuelBoom": {
        "fuelFlowSub": "transfert d'hydrogène",
        "quantumFlowSub": "transfert de quantum",
        "captureRadiusSub": "tolérance d'amarrage",
        "equipment": "Équipement",
        "hint": "Débits de transfert du bras de ravitaillement et tolérance d'amarrage de sa buse."
      },
      "combat": {
        "title": "Combat",
        "dps": "DPS en rafale",
        "dpsSub": "%{count} armes",
        "sustained": "DPS soutenu",
        "sustainedSub": "avec régénération et chaleur",
        "alpha": "Alpha",
        "alphaSub": "par salve",
        "weapons": "Armes",
        "missileDamage": "Dégâts des missiles",
        "composition": "Composition des dégâts",
        "damagePhysical": "Physique",
        "damageEnergy": "Énergie",
        "damageDistortion": "Distorsion",
        "damageThermal": "Thermique",
        "hint": "DPS de l'équipement par défaut. Le DPS soutenu tient compte de la régénération de la réserve d'énergie de chaque arme et de son cycle de surchauffe. Les missiles sont exclus."
      },
      "power": {
        "title": "Répartition de l'énergie",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Réinitialiser",
        "auto": "Auto",
        "aimAssist": "Aide à la visée",
        "cooling": "Refroidissement",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Cliquez pour changer d'axe (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segments",
        "hint": "Répartissez l'énergie entre les systèmes. Le DPS soutenu des armes dépend de l'énergie qu'elles reçoivent ; le reste est équilibré automatiquement.",
        "families": {
          "weapon": "Armes",
          "shield": "Boucliers",
          "engine": "Moteur",
          "radar": "Radar",
          "coolers": "Refroidisseurs",
          "qdrive": "Moteur quantique",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Support vital",
          "miningLaser": "Laser de minage",
          "salvage": "Récupération",
          "tractorBeam": "Rayon tracteur",
          "towingbeam": "Rayon de remorquage"
        }
      },
      "defense": {
        "title": "Défense",
        "shieldHp": "HP des boucliers",
        "shieldHpSub": "%{count} générateurs",
        "shieldRegen": "Régénération",
        "shieldResistances": "Résistance",
        "shieldAbsorption": "Absorption",
        "armor": "Blindage",
        "deflection": "Déflexion",
        "armorReduction": "Réduction des dégâts",
        "armorSelfResistance": "Résistance propre",
        "armorSignature": "Signature",
        "damageType": {
          "physical": "Phys",
          "energy": "Énergie",
          "distortion": "Distors.",
          "thermal": "Thermique"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "Valeurs de bouclier et de blindage de l'équipement par défaut. Une absorption inférieure à 100 % signifie que ce type de dégâts atteint la coque alors que les boucliers sont encore actifs.",
        "openDeflectionCheck": "Test de déflexion"
      },
      "deflectionCheck": {
        "title": "Test de déflexion",
        "intro": "— quelles armes percent ses défenses ?",
        "noArmor": "Ce vaisseau ne porte aucun blindage, rien n'est donc dévié.",
        "allSizes": "Toutes",
        "deflected": "dévié",
        "pierce": "percent",
        "weapon": "Arme",
        "boundary": "Seuil de déflexion",
        "alpha": "Alpha",
        "threshold": "Seuil franchi",
        "absorbed": "absorbé",
        "versus": "vs",
        "hoverHint": "Survolez une arme pour le détail par type.",
        "note": "L'alpha est comparé par projectile, après l'absorption du bouclier — une arme perce dès qu'elle dépasse la déflexion sur un type de dégâts. Les types que les boucliers absorbent totalement n'atteignent jamais le blindage : ils sont donc listés comme absorbés plutôt que déviés, arrêtés par le bouclier et non par la coque. L'absorption du bouclier est interpolée sur sa plage min–max publiée en fonction de sa santé, et la déflexion du blindage évolue linéairement avec la santé du blindage. Les faisceaux laser sont exclus — ils infligent des dégâts continus, il n'y a donc pas d'alpha par tir à tester.",
        "margin": "Marge",
        "reachesArmor": "Atteint le blindage",
        "stoppedByShields": "Absorbé par le bouclier",
        "verdict": {
          "absorbed": "Absorbé",
          "deflected": "Dévié",
          "pierces": "Percé"
        },
        "shieldHealth": "Santé du bouclier",
        "armorHealth": "Santé du blindage",
        "absorb": "Absorb.",
        "defl": "Défl.",
        "type": "Type",
        "size": "Taille"
      },
      "hull": {
        "category": {
          "vital": "Vital",
          "secondary": "Secondaire",
          "breakable": "Destructible",
          "subpart": "Sous-pièces",
          "cosmetic": "Cosmétique"
        },
        "composition": "Composition de la coque",
        "door": "Porte",
        "doors": "Portes",
        "doorsNote": "Les portes intérieures destructibles forment une zone à part — elles disposent de leur propre santé et ne comptent pas dans les HP de la coque.",
        "doorsSub": "%{count} destructibles",
        "hint": "Les HP de la coque sont la somme de la santé de toutes les pièces.",
        "hullHp": "HP de la coque",
        "hullHpSub": "total sur toutes les pièces",
        "integrity": "Intégrité de la coque",
        "noHp": "aucun HP",
        "parts": "Pièces de la coque",
        "partsNote": "Les pièces sont classées par santé ; les pièces cosmétiques (portes, échelles, volets) n'ont pas de santé propre. Les fichiers du jeu n'exposent aucun lien parent/enfant, il s'agit donc d'une liste à plat plutôt que d'un arbre structurel.",
        "partsSub": "réparties sur %{count} catégories",
        "partsTree": "Pièces · damageMax",
        "showParts": "Afficher les pièces de la coque",
        "title": "Coque",
        "totalHp": "HP totaux de la coque"
      },
      "manufacturer": {
        "longName": "Nom complet",
        "code": "Code",
        "logo": "Logo",
        "logoOverridden": "Logo (remplacé)",
        "icon": "Icône (fichiers du jeu)",
        "iconOverridden": "Icône (remplacée)",
        "scRef": "SC Ref"
      },
      "fundingGoal": {
        "title": "Titre",
        "description": "Description",
        "amount": "Montant",
        "currency": "Devise",
        "effectiveFrom": "En vigueur à partir du",
        "endedAt": "Terminé le"
      },
      "supporterContribution": {
        "name": "Nom du soutien",
        "user": "Compte lié",
        "amount": "Montant",
        "currency": "Devise",
        "anonymous": "Anonyme",
        "recurring": "Récurrent",
        "startedAt": "Démarré le",
        "endedAt": "Terminé le",
        "note": "Note interne",
        "stats": {
          "total": "Total",
          "count": "Contributions",
          "currentMonth": "Ce mois-ci",
          "currentMonthCount": "%{count} contributions",
          "recurringCount": "Récurrentes",
          "anonymousCount": "Anonymes"
        },
        "chart": {
          "contributions": "Contributions",
          "goal": "Objectif"
        }
      },
      "itemPrice": {
        "price": "Prix",
        "location": "Emplacement",
        "locationUrl": "URL de l'emplacement"
      },
      "video": {
        "url": "URL",
        "videoType": "Type"
      },
      "modelModule": {
        "name": "Nom",
        "description": "Description",
        "price": "Prix",
        "pledgePrice": "Prix Pledge",
        "productionStatus": "Statut de Production",
        "scKey": "SC Key",
        "storeImage": "Image de Boutique",
        "active": "Actif ?",
        "hidden": "Caché ?"
      },
      "dock": {
        "name": "Nom",
        "dockType": "Type de quai",
        "shipSize": "Taille du vaisseau"
      },
      "modelPosition": {
        "name": "Nom",
        "positionType": "Type de poste",
        "source": "Source",
        "position": "Ordre de tri",
        "types": {
          "pilot": "Pilote",
          "copilot": "Copilote",
          "turret_gunner": "Artilleur de tourelle",
          "engineer": "Ingénieur",
          "gunner": "Artilleur",
          "loadmaster": "Chef de soute",
          "passenger": "Passager",
          "operator": "Opérateur",
          "custom": "Personnalisé"
        }
      },
      "modelHardpoint": {
        "name": "Nom",
        "key": "Clé",
        "source": "Source",
        "group": "Groupe",
        "hardpointType": "Type",
        "size": "Taille",
        "category": "Catégorie",
        "subCategory": "Sous-catégorie",
        "details": "Détails",
        "mount": "Support",
        "itemSlots": "Emplacements d'objets",
        "loadoutIdentifier": "Identifiant de configuration"
      },
      "modelHardpointLoadout": {
        "name": "Nom"
      },
      "modelUpgrade": {
        "name": "Nom",
        "description": "Description",
        "pledgePrice": "Prix de Pledge",
        "active": "Actif ?",
        "hidden": "Masqué ?"
      },
      "modelModulePackage": {
        "name": "Nom",
        "description": "Description",
        "pledgePrice": "Prix de Pledge",
        "modules": "Modules",
        "active": "Actif ?",
        "hidden": "Masqué ?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotation (°)"
      },
      "modelLoaner": {
        "hidden": "Masqué ?",
        "loanerModel": "Modèle de prêt"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "Masqué ?",
        "active": "Actif ?",
        "onSale": "En vente",
        "pledgePrice": "Prix de Pledge",
        "productionStatus": "Statut de production",
        "productionNote": "Note de production",
        "copyHint": "Sélectionnez le vaisseau cible vers lequel copier cette peinture. Les données de la peinture ne sont pas modifiées lors de la copie.",
        "bulkCopyHint": "Sélectionnez le vaisseau cible vers lequel copier ces %{count} peintures. Les données des peintures ne sont pas modifiées lors de la copie.",
        "copySameModel": "Le vaisseau cible doit être différent du vaisseau source."
      },
      "component": {
        "size": "Taille : %{size}",
        "grade": "Grade",
        "hidden": "Masqué ?",
        "componentClass": "Classe de composant",
        "componentType": "Type de composant",
        "componentSubType": "Sous-type de composant",
        "itemType": "Type d'objet",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "hardpoint": {
        "legend": {
          "headline": "Légende",
          "slotTaken": "Emplacement pris",
          "slotAvailable": "Emplacement disponible"
        },
        "size": "Taille",
        "rackSize": "Taille de la rampe",
        "details": "Détails",
        "group": "Groupe",
        "thrusters": {
          "thrust": "Poussée",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "refuelBoom": {
          "captureRadius": "Rayon de capture",
          "fuelFlowRate": "Débit de carburant",
          "quantumFuelFlowRate": "Débit de carburant Quantum"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "DPS en rafale",
          "sustainedDps": "DPS soutenu",
          "efficiency": "Efficacité",
          "penetration": "Pénétration",
          "fireRate": "Cadence de tir",
          "speed": "Vitesse",
          "range": "Portée",
          "ammo": "Munitions",
          "ammoCost": "Coût des munitions",
          "pool": "Réserve d'énergie",
          "maxRegen": "Régén. max/s",
          "costPerShot": "Énergie/tir",
          "heatPerShot": "Chaleur/tir",
          "heatPerSecond": "Chaleur/s",
          "chargeTime": "Temps de charge",
          "fullDamageRange": "Portée DMG max",
          "zeroDamageRange": "Portée DMG nuls",
          "damagePhysical": "Physique",
          "damageEnergy": "Énergie",
          "damageDistortion": "Distorsion",
          "damageThermal": "Thermique"
        },
        "missiles": {
          "damage": "Dégâts",
          "speed": "Vitesse",
          "range": "Portée",
          "lockRange": "Portée de verrouillage",
          "lockTime": "Temps de verrouillage",
          "trackingSignal": "Suivi"
        },
        "tractorBeams": {
          "maxForce": "Force max.",
          "minForce": "Force min.",
          "range": "Portée",
          "cone": "Cône",
          "tetherBreak": "Rupture du lien",
          "cargoForce": "Force cargaison",
          "cargoRange": "Portée cargaison",
          "towForce": "Force de remorquage",
          "towDistance": "Portée de remorquage",
          "quantumTowMass": "Masse max. en QT",
          "rotationSpeed": "Rotation",
          "moveSpeed": "Vitesse de déplacement"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Temps de régén.",
          "downedRegenDelay": "Délai après chute",
          "damagedRegenDelay": "Délai après dégâts",
          "resistancePhysical": "Rés. phys.",
          "resistanceEnergy": "Rés. énergie",
          "resistanceDistortion": "Rés. distors."
        },
        "coolers": {
          "coolingRate": "Refroidissement"
        },
        "powerPlants": {
          "output": "Puissance",
          "pips": "Pips"
        },
        "quantumDrives": {
          "speed": "Vitesse",
          "range": "Portée",
          "fuelConsumption": "Consommation",
          "spoolUpTime": "Amorçage",
          "cooldownTime": "Refroidissement",
          "splineSpeed": "Orbite",
          "accel": "Accél."
        },
        "jumpDrives": {
          "fuelEfficiency": "Efficacité du carburant",
          "alignRate": "Taux d'alignement",
          "tuneRate": "Taux de réglage",
          "alignDecay": "Perte d'alignement",
          "tuneDecay": "Perte de réglage"
        },
        "radar": {
          "aimAssistRange": "Portée d'assistance",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS"
        },
        "armor": {
          "hp": "HP",
          "physical": "Physique",
          "energy": "Énergie",
          "distortion": "Distorsion",
          "thermal": "Thermique",
          "deflectPhysical": "Défl. phys.",
          "deflectEnergy": "Défl. énergie",
          "selfPhysical": "Rés. propre phys.",
          "selfEnergy": "Rés. propre énergie"
        },
        "fuelIntakes": {
          "pushRate": "Débit d'admission",
          "minRate": "Débit min."
        },
        "sources": {
          "game_files": "Fichiers du jeu",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "Vue",
          "compact": "Compacte",
          "expanded": "Détaillée"
        },
        "fuelTanks": {
          "hydrogen": "Réservoir de carburant hydrogène",
          "quantum": "Réservoir de carburant Quantum"
        },
        "jumpDrive": "Moteur de saut",
        "maxContainerSize": "Taille max. de conteneur",
        "groups": {
          "avionic": "Avioniques",
          "system": "Systèmes",
          "propulsion": "Propulsion",
          "thruster": "Propulseur",
          "weapon": "Armes",
          "defense": "Défense",
          "other": "Autre",
          "auxiliary": "Auxiliaire",
          "seat": "Sièges",
          "external_fuel_tank": "Réservoirs de carburant externes",
          "refuel_boom": "Perche de ravitaillement"
        },
        "types": {
          "radar": "Radar",
          "computers": "Ordinateurs",
          "power_plants": "Générateurs",
          "coolers": "Refroidisseurs",
          "shield_generators": "Générateurs de bouclier",
          "fuel_intakes": "Consommation de carburant",
          "fuel_tanks": "Réservoirs de carburant",
          "quantum_drives": "Moteurs quantiques",
          "jump_modules": "Modules de Saut",
          "jumpdrive": "Modules de saut",
          "quantum_fuel_tanks": "Réservoirs de carburant quantique",
          "main_thrusters": "Propulseurs Principaux",
          "maneuvering_thrusters": "Propulseurs de manœuvre",
          "weapons": "Armes",
          "turrets": "Tourelles",
          "missiles": "Missiles",
          "utility_items": "Objets Utilitaires",
          "utility": "Objets utilitaires",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Sélectionner un module —",
        "selectModule": "Sélectionner un module",
        "clearModule": "Effacer la sélection",
        "categories": {
          "radar": "Radar",
          "armor": "Blindage",
          "relay": "Relais",
          "countermeasures": "Contre-mesures",
          "lifesupport": "Support vital",
          "selfdestruct": "Autodestruction",
          "batteries": "Batteries",
          "computers": "Ordinateurs",
          "powerplant": "Réacteurs",
          "cooler": "Refroidisseurs",
          "module": "Modules",
          "shieldgenerator": "Générateurs de boucliers",
          "fuel_intakes": "Prises de carburant",
          "fueltanks": "Réservoirs de carburant",
          "external_fuel_tanks": "Réservoirs de carburant externes",
          "refuel_boom": "Perche de ravitaillement",
          "quantumdrive": "Moteurs Quantum et modules de saut",
          "jump_modules": "Modules de saut",
          "jumpdrive": "Modules de saut",
          "quantum_fuel_tanks": "Réservoirs de carburant Quantum",
          "main_thrusters": "Propulseurs principaux",
          "maneuvering_thrusters": "Propulseurs de manœuvre",
          "retro_thrusters": "Rétro-propulseurs",
          "vtol_thrusters": "Propulseurs VTOL",
          "weapons": "Armes",
          "weapon_mounts": "Supports d'armes",
          "turret": "Tourelles",
          "missiles": "Missiles",
          "missile_racks": "Racks de missiles",
          "utility_items": "Objets utilitaires",
          "utility": "Objets utilitaires",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Station de remplissage de récupération",
          "cargogrid": "Grille de cargaison",
          "seat": "Sièges"
        }
      },
      "blank": {
        "propulsion": "Aucune propulsion présente",
        "ordnance": "Aucune munition présente",
        "modular": "Aucun module présent",
        "avionics": "Aucun Avionique présent",
        "fleetInvites": "Aucune invitation présente",
        "shopCommodities": "Aucun produit disponible",
        "userShips": "Votre Hangar est actuellement vide. Pour ajouter des Vaisseaux / Véhicules à votre Hangar, cliquez sur l'icône suivante sur n'importe quel vaisseau de la Base de données :"
      },
      "user": {
        "rsiHandle": "Pseudo",
        "rsiHandleVerified": "Vérifié via Citizen iD",
        "location": "Emplacement",
        "currentSystem": "Système stellaire actuel",
        "tester": "Testeur ?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Adresse email non confirmée",
        "saleNotify": "Je veux recevoir les notifications de vente",
        "publicHangar": "Hangar public activé",
        "publicHangarLoaners": "Afficher le marqueur des prêteurs dans le Hangar Public",
        "publicHangarStats": "Statistiques du Hangar public activées",
        "publicWishlist": "Liste de souhaits publique activée",
        "hideOwner": "Masquer la propriété pour les flottes",
        "tracking": "Autoriser l'analyse d'utilisation anonyme",
        "lastActiveAt": "Dernière activité",
        "confirmedAt": "Confirmé le",
        "dateFormat": "Format de date",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        }
      },
      "adminUser": {
        "superAdmin": "Super administrateur",
        "passwordConfirmation": "Confirmation du mot de passe"
      },
      "vehicle": {
        "name": "Nom",
        "states": "États",
        "serial": "Série",
        "owner": "commandé par",
        "flagship": "Vaisseau amiral",
        "wanted": "Recherché",
        "loaner": "Prêteur",
        "bundled": "Inclus",
        "bundledWith": "Inclus avec %{parent}",
        "public": "Visibilité publique",
        "fullPublic": "Visibilité Publique incluant le nom",
        "publicShort": "Publique",
        "nameVisible": "Visibilité publique",
        "saleNotify": "Je souhaite recevoir les notifications de vente",
        "hangarGroups": "Groupes",
        "selectGroup": "Sélectionner un Groupe",
        "modelPaintSelect": {
          "nullablePrompt": "Sélectionner une peinture",
          "label": "Peinture"
        },
        "bulkGroupEdit": {
          "hint": "Les groupes existants seront remplacés !"
        },
        "hasLoaners": "Prêteurs",
        "boughtViaSelect": {
          "label": "Acheté via"
        }
      },
      "image": {
        "active": "Actif ?",
        "background": "Utiliser comme arrière-plan ?",
        "caption": "Légende",
        "enabled": "Activé?",
        "file": "Fichier image",
        "global": "Global ?",
        "delete": "Supprimer",
        "start": "Démarrer",
        "cancel": "Annuler",
        "processing": "Traitement en cours...",
        "error": "Erreur",
        "name": "Nom",
        "size": "Taille du fichier",
        "dropzone": "Déposer les images ici",
        "cancelUpload": "Annuler le téléchargement",
        "startUpload": "Démarrer le téléchargement",
        "selectImages": "Ajouter des images...",
        "selectFolder": "Ajouter un dossier..."
      },
      "signup": {
        "link": "Vous n’avez pas de compte ?",
        "privacyPolicy": "En créant un compte FleetYards, vous acceptez notre"
      },
      "privacyPolicy": "Politique de Confidentialité",
      "login": "Nom d'utilisateur ou e-mail",
      "username": "Nom d’utilisateur",
      "twoFactorCode": "Code d’authentification à deux facteurs",
      "confirmationCode": "Code de confirmation",
      "email": "E-mail",
      "avatar": "Avatar",
      "alreadyRegistered": "Vous avez déjà un compte?",
      "currentPassword": "Mot de passe actuel",
      "password": "Mot de passe",
      "passwordConfirmation": "Confirmation du mot de passe",
      "rememberMe": "Se souvenir de moi",
      "emptyList": "Pas de %{name} présent",
      "all": "Tout",
      "supportUs": "Soutenez FleetYards.net",
      "account": {
        "destroyInfo": "Si vous voulez supprimer votre compte et enlever toutes vos informations de Fleetyards.net et ses Services cliquez sur le Bouton ci-dessous. Sachez qu'il s'agit d'une action permanente qui ne peut pas être révoquée.",
        "calendarSubscription": {
          "intro": "Générez un lien privé pour ajouter les événements auxquels vous êtes inscrit à votre application de calendrier personnelle (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Collez le lien dans votre application de calendrier sous « S'abonner à un calendrier » ou « Ajouter par URL ». Toute personne possédant ce lien peut voir les événements auxquels vous êtes inscrit — gardez-le privé."
        }
      },
      "filters": {
        "components": {
          "name": "Nom",
          "itemType": "Type d'objet",
          "componentClass": "Classe de composant",
          "buyPriceGt": "Prix d'achat >=",
          "buyPriceLt": "Prix d'achat <=",
          "sellPriceGt": "Prix de vente >=",
          "sellPriceLt": "Prix de vente <=",
          "storeImageBlank": "Sans image de boutique ?"
        },
        "shops": {
          "name": "Nom",
          "type": "Type",
          "celestialObject": "Objet Céleste",
          "model": "Vaisseau",
          "equipment": "Équipement",
          "component": "Composant",
          "commodity": "Marchandise",
          "commodityType": "Type de marchandise",
          "starsystem": "Système planétaire",
          "station": "Station"
        },
        "shopCommodities": {
          "commodityType": "Type de marchandise",
          "station": "Station",
          "shopId": "Magasin",
          "equipment": "Équipement",
          "component": "Composant",
          "componentItemTypeFilter": "Types d'éléments de composant",
          "equipmentItemTypeFilter": "Types d'objet d'équipement",
          "equipmentTypeFilter": "Type d'équipement",
          "equipmentSlotFilter": "Emplacement d'équipement",
          "commodity": "Marchandise",
          "model": "Vaisseau",
          "name": "Nom"
        },
        "shopItems": {
          "category": "Catégorie",
          "subCategory": "Sous catégorie",
          "name": "Nom",
          "manufacturer": "Fabricant",
          "minPrice": "Prix min.",
          "maxPrice": "Prix max."
        },
        "stations": {
          "name": "Nom",
          "celestialObject": "Objet Céleste",
          "starsystem": "Système planétaire",
          "type": "Type de Station",
          "shops": "Magasins",
          "docks": "Quais",
          "habs": "Habitation ?",
          "cargoHub": "plate-forme de fret",
          "refinery": "Station de raffinerie?"
        },
        "vehicles": {
          "name": "Nom ou nom du vaisseau",
          "lengthLt": "Longueur <=",
          "lengthGt": "Longueur >=",
          "pledgePriceLt": "Prix du Pledge <=",
          "pledgePriceGt": "Prix du Pledge >=",
          "priceLt": "Prix <=",
          "priceGt": "Prix >=",
          "wanted": "Recherché",
          "hidden": "Masqué",
          "public": "Publique",
          "group": "Groupe",
          "loaner": "Prêteurs",
          "bundled": "Snub Crafts inclus",
          "boughtVia": "Acheté via?"
        },
        "tradeRoutes": {
          "sortBy": "Trier par",
          "sortByValues": {
            "percent": "Pourcentage Max.",
            "profit": "Bénéfice max."
          },
          "cargoShip": "Avec le vaisseau de marchandise ?",
          "origin": "De ?",
          "destination": "Vers?",
          "excludeCommodityType": "Exclure le type de marchandise",
          "originCelestialObject": "Lieu d'origine d'objet céleste",
          "destinationCelestialObject": "Destination d'objet céleste",
          "originStarsystem": "Système planétaire d'origine",
          "destinationStarsystem": "Destination du système planétaire"
        },
        "models": {
          "name": "Nom",
          "shipRole": "Rôle du vaisseau",
          "classification": "Classification",
          "focus": "Spécialisation",
          "manufacturer": "Fabricant",
          "onSale": "En Vente",
          "size": "Taille",
          "dockSize": "Taille du quai",
          "price": "Prix",
          "pledgePrice": "Prix du Pledge",
          "productionStatus": "Statut de la production",
          "lengthLt": "Longueur <=",
          "lengthGt": "Longueur >=",
          "beamLt": "Rayon <=",
          "beamGt": "Rayon >=",
          "heightLt": "Hauteur <=",
          "heightGt": "Hauteur >=",
          "pledgePriceLt": "Prix du Pledge <=",
          "pledgePriceGt": "Prix du Pledge >=",
          "priceLt": "Prix <=",
          "priceGt": "Prix >=",
          "willItFit": "Est-ce que cela conviendra ?",
          "withCargo": "Avec cargaison ?",
          "scKeyBlank": "Sans SC Key ?",
          "positionsNeedCuration": "Postes à curer ?",
          "fleetchartImageBlank": "Sans image de diagramme de flotte ?",
          "holoBlank": "Sans Holo ?",
          "frontViewBlank": "Sans image de vue de face ?",
          "topViewColoredBlank": "Sans image de vue de dessus colorée ?",
          "scIdentifierBlank": "Sans identifiant SC ?"
        },
        "modelModules": {
          "name": "Nom"
        },
        "manufacturers": {
          "name": "Nom",
          "withModels": "Avec modèles",
          "logoBlank": "Sans logo"
        },
        "supporterContributions": {
          "name": "Rechercher par nom",
          "recurring": "Récurrentes",
          "anonymous": "Anonymes",
          "startedAtGteq": "Démarrées à partir du",
          "startedAtLteq": "Démarrées jusqu'au",
          "user": "Compte lié",
          "linked": "Liaison au compte",
          "linkedOnly": "Liées",
          "unlinkedOnly": "Non liées"
        },
        "adminNotifications": {
          "search": "Rechercher"
        },
        "images": {
          "station": "-",
          "model": "Vaisseau"
        },
        "users": {
          "search": "Rechercher",
          "username": "Nom d'utilisateur",
          "email": "E-mail",
          "rsiHandle": "Pseudo RSI"
        },
        "fleets": {
          "name": "Nom",
          "fid": "FID",
          "member": "Membre",
          "members": {
            "role": "Rôle",
            "state": "Statut",
            "acceptedAtGt": "Rejoint depuis",
            "acceptedAtLt": "Rejoint jusqu'à",
            "invitedAtGt": "Invité depuis",
            "invitedAtLt": "Invité jusqu'à",
            "requestedAtGt": "Demandé depuis",
            "requestedAtLt": "Demandé jusqu'à",
            "declinedAtGt": "Refusé depuis",
            "declinedAtLt": "Refusé jusqu'à"
          },
          "inviteUrls": {
            "expiresAfter": "Expire après",
            "limit": "Nombre maximum d’utilisations"
          },
          "logistics": {
            "search": "Rechercher des objets..."
          }
        },
        "manufacturer": "Fabricant",
        "commodities": {
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Prix d'achat >=",
          "buyPriceLt": "Prix d'achat <=",
          "sellPriceGt": "Prix de vente >=",
          "sellPriceLt": "Prix de vente <=",
          "storeImageBlank": "Sans image de boutique ?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "buyPriceGt": "Prix d'achat >=",
          "buyPriceLt": "Prix d'achat <=",
          "sellPriceGt": "Prix de vente >=",
          "sellPriceLt": "Prix de vente <=",
          "storeImageBlank": "Sans image de boutique ?"
        },
        "notifications": {
          "search": "Rechercher"
        }
      },
      "station": {
        "docks": "Quais",
        "location": "Localisation",
        "type": "Type",
        "habitation": "Habitation",
        "habs": "Habitat",
        "shops": "Magasins",
        "locationPrefix": {
          "default": "Activé",
          "asteriod": "à proximité d'un astéroïde",
          "orbit": "autour de l'orbite"
        },
        "locationSuffix": "à proximité de %{location}"
      },
      "tradeRoutes": {
        "buy": "Acheter pour: %{uec}",
        "sell": "Vendre pour: %{uec}",
        "cargoShip": "pour %{cargo} SCU",
        "sortByPercent": "Trier par Pourcentage",
        "sortByProfit": "Trier par Bénéfice",
        "sortByStation": "Trier par Station",
        "showAveragePrices": "Affichage des prix moyens",
        "showLatestPrices": "Affichage des derniers prix"
      },
      "hardpoints": {
        "prefix": "Essayer les configurations avec",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Statistiques basées sur les formules de"
      },
      "scunpacked": {
        "prefix": "Configurations basées sur les produits développés par Gamefiles ",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Sélectionner un vaisseau"
      },
      "addAddon": {
        "nullablePrompt": ""
      },
      "table": {
        "selected": "%{count} sélectionné"
      },
      "commodityPrice": {
        "shopId": "Magasin",
        "station": "Station",
        "commodityItemType": "Type de marchandise",
        "commodityItemId": "Article de marchandise",
        "item": "Magasins de marchandise",
        "price": "Prix",
        "type": "Type",
        "shop": "Magasin",
        "submittedBy": "Soumis par"
      },
      "syncExtension": {
        "warnings": "Avertissements",
        "status": {
          "started": "Import démarré...",
          "finished": "Import terminé",
          "failed": "Échec de l'import !"
        },
        "processSteps": {
          "fetchHangar": "Récupération des données du hangar RSI",
          "submitData": "Envoi des données au backend de Fleetyards.net"
        },
        "sessionStatus": "Statut de session RSI",
        "checkIdentity": "Vérifier la session RSI",
        "identityStatus": {
          "pending": "Vérification...",
          "notFound": "non trouvé",
          "connected": "connecté"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Pages",
          "all": "Tous les articles de promesse",
          "ships": "Vaisseaux",
          "components": "Modules",
          "skins": "Peintures",
          "upgrades": "Améliorations"
        },
        "importedItems": {
          "importedVehicles": "Vaisseaux ajoutés",
          "foundVehicles": "Vaisseaux trouvés",
          "movedVehiclesToWanted": "Vaisseaux déplacés vers la liste de souhaits",
          "missingModels": "Vaisseaux non trouvés",
          "importedComponents": "Composants ajoutés",
          "foundComponents": "Composants trouvés",
          "missingComponents": "Composants non trouvés",
          "missingComponentVehicles": "Aucun vaisseau correspondant trouvé pour les composants",
          "importedUpgrades": "Améliorations ajoutées",
          "foundUpgrades": "Améliorations trouvées",
          "missingUpgrades": "Améliorations non trouvées",
          "missingUpgradeVehicles": "Aucun vaisseau correspondant trouvé pour les améliorations",
          "new": "Nouveau",
          "updated": "Mis à jour",
          "movedToWanted": "Déplacé vers la liste de souhaits",
          "missing": "Impossible d'importer"
        }
      },
      "cargoGridViewer": {
        "capacity": "Capacité",
        "maxContainerSize": "Conteneur max.",
        "packed": "Empaqueté",
        "totalCargo": "Cargaison totale",
        "didNotFit": "Ne rentre pas",
        "openInTool": "Ouvrir dans l'outil de grille de cargaison",
        "enoughShips": "Quatre vaisseaux remplissent la grille.",
        "addShip": "Ajouter un vaisseau",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "Moteur quantique",
        "fuelUsage": "Consommation de carburant",
        "travelTime": "Temps de trajet",
        "poweredBy": "basé sur",
        "rank": "#",
        "size": "Taille",
        "grade": "Grade",
        "sizeValue": "S%{size}",
        "intro": "Le temps que met chaque moteur quantique pour votre saut — et le carburant quantique qu'il consomme.",
        "jumpDistance": "Distance de saut",
        "distanceHint": "1 Mkm équivaut à un million de kilomètres. Traverser Stanton en demande environ 40.",
        "filters": "Filtres",
        "resetFilters": "Réinitialiser",
        "barLegend": "La barre indique le temps par rapport au moteur le plus lent",
        "count": "%{count} moteurs",
        "countFiltered": "%{count} sur %{total} moteurs",
        "noMatch": "Aucun moteur ne correspond à ces filtres.",
        "presets": {
          "moon": "Saut lunaire",
          "short": "Saut court",
          "system": "Traversée de Stanton",
          "far": "Longue distance"
        }
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Utilisateurs en ligne",
            "totalUsers": "Utilisateurs totaux",
            "totalShips": "Vaisseaux totaux",
            "newShipsInYear": "Nouveaux vaisseaux en %{year}",
            "totalFleets": "Flottes totales"
          }
        },
        "modelHardpoint": {
          "loadouts": "Configurations"
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "manual": "Manuel"
          }
        },
        "resourceAccess": {
          "title": "Accès aux ressources",
          "groups": {
            "ship_data": "Données des vaisseaux",
            "community": "Communauté",
            "system": "Système"
          },
          "privileges": {
            "models": "Modèles",
            "model_modules": "Modules de modèle",
            "components": "Composants",
            "manufacturers": "Fabricants",
            "vehicles": "Véhicules",
            "images": "Images",
            "fleets": "Flottes",
            "users": "Utilisateurs",
            "supporters": "Soutiens",
            "admins": "Administrateurs",
            "oauth_applications": "Applications OAuth",
            "maintenance": "Maintenance",
            "imports": "Imports",
            "features": "Fonctionnalités",
            "workers": "Workers",
            "pghero": "PgHero",
            "rsi-api-status": "État de l'API RSI",
            "stats": "Statistiques"
          }
        },
        "versions": {
          "blank": "vide",
          "revertQuestion": "Rétablir ?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "Fichiers du jeu",
            "sc_loader": "Fichiers du jeu",
            "uex_price_sync": "Synchronisation des prix UEX",
            "unknown": "Inconnu"
          }
        }
      },
      "hangarTable": {
        "extraColumns": "Colonnes",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Image large",
          "angledView": "Image 3D",
          "angledViewWide": "Image 3D large",
          "modelManufacturerName": "Fabricant",
          "modelLength": "Longueur",
          "modelBeam": "Largeur",
          "modelHeight": "Hauteur",
          "modelMass": "Masse",
          "modelCargo": "Cargaison",
          "modelMinCrew": "Équipage",
          "modelMaxCrew": "Équipage max.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Vitesse max.",
          "modelGroundMaxSpeed": "Vitesse au sol",
          "modelFocus": "Spécialisation",
          "modelProductionStatus": "Statut de production",
          "modelPrice": "Prix",
          "modelPledgePrice": "Prix de Pledge"
        }
      },
      "fleetTable": {
        "extraColumns": "Colonnes",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Image large",
          "angledView": "Image 3D",
          "angledViewWide": "Image 3D large",
          "modelManufacturerName": "Fabricant",
          "modelLength": "Longueur",
          "modelBeam": "Largeur",
          "modelHeight": "Hauteur",
          "modelMass": "Masse",
          "modelCargo": "Cargaison",
          "modelMinCrew": "Équipage",
          "modelMaxCrew": "Équipage max.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Vitesse max.",
          "modelGroundMaxSpeed": "Vitesse au sol",
          "modelProductionStatus": "Statut de production",
          "modelPrice": "Prix",
          "modelPledgePrice": "Prix de Pledge",
          "owner": "Propriétaire"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "inProgress": "in progress",
        "drafts": "drafts",
        "noInventories": "No inventories yet.",
        "noRequests": "No requests found.",
        "noItems": "No entries in this inventory.",
        "entriesCount": "entries",
        "comments": "comments",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "fulfilled": "Fulfilled",
        "itemFulfilled": "Fulfilled",
        "itemPending": "Pending",
        "requestTitle": "Title",
        "description": "Description",
        "requestType": "Type",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "approvedBy": "Approved by",
        "fulfilledBy": "Fulfilled by",
        "addComment": "Write a comment...",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved",
          "in_progress": "In Progress",
          "fulfilled": "Fulfilled",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "supply": "Supply",
          "outfitting": "Outfitting",
          "general": "General"
        },
        "priorities": {
          "routine": "Routine",
          "standard": "Standard",
          "urgent": "Urgent",
          "critical": "Critical"
        },
        "searchInventories": "Search inventories...",
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityShort": "Quality",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "au-delà de la capacité de fret",
        "cargoGrid": "Grille de fret",
        "shipInventory": "Inventaire du vaisseau",
        "remaining": "Restant",
        "unmeasured": "%{count} pas encore mesurés"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "Boîte de réception",
        "archive": "Archives",
        "unreadOnly": "Non lues uniquement",
        "status": "Statut",
        "severity": "Gravité",
        "type": "Type",
        "selectPrompt": "Sélectionnez une notification pour la lire",
        "noBody": "Cette notification ne contient aucun détail supplémentaire.",
        "lastSeen": "Vue la dernière fois",
        "expires": "Expire",
        "severities": {
          "info": "Info",
          "warning": "Avertissement",
          "error": "Erreur"
        },
        "types": {
          "paints_import": "Import des peintures",
          "modules_import": "Import des modules",
          "loaner_sync": "Synchronisation des prêts",
          "uex_prices_import": "Synchronisation des prix UEX",
          "uex_commodity_prices_import": "Synchronisation des marchandises UEX",
          "new_supporter": "Nouveau soutien",
          "rsi_api_blocked": "API RSI bloquée",
          "rsi_api_unblocked": "API RSI rétablie",
          "weekly_stats": "Rapport hebdomadaire",
          "ship_matrix_import": "Import Ship Matrix",
          "sc_data_import": "Import sc_data",
          "import_run": "Import"
        }
      },
      "optional": "facultatif",
      "notificationActions": {
        "open": "Ouvrir",
        "openHangar": "Ouvrir le hangar",
        "openWishlist": "Ouvrir la liste de souhaits",
        "openModel": "Voir le vaisseau",
        "openInvite": "Voir l'invitation",
        "reviewRequest": "Examiner la demande",
        "openMembers": "Voir les membres",
        "openFleet": "Ouvrir la flotte",
        "openInventory": "Ouvrir l'inventaire",
        "openEvent": "Ouvrir l'événement",
        "openRoster": "Voir les inscriptions",
        "addToCalendar": "Ajouter au calendrier",
        "openStore": "Boutique Pledge",
        "accept": "Accepter",
        "decline": "Décliner",
        "signUp": "S'inscrire",
        "withdraw": "Se désinscrire",
        "syncAgain": "Synchroniser à nouveau",
        "markAsBought": "Marquer comme acheté",
        "unavailable": "Ceci n'est plus disponible."
      },
      "notificationTypes": {
        "channels": {
          "app": "Application",
          "mail": "Email",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Compte et hangar",
          "fleetMembership": "Adhésion à une flotte",
          "fleetEvents": "Événements de flotte"
        },
        "hangar_create": "Vaisseau ajouté au hangar",
        "hangar_destroy": "Vaisseau retiré du hangar",
        "hangar_sync_finished": "Synchronisation du hangar terminée",
        "hangar_sync_failed": "Échec de la synchronisation du hangar",
        "wishlist_create": "Ajouté à la liste de souhaits",
        "wishlist_destroy": "Retiré de la liste de souhaits",
        "model_on_sale": "Modèle en vente",
        "new_model": "Nouveau modèle sorti",
        "fleet_invite": "Invitation de flotte reçue",
        "fleet_member_requested": "Adhésion demandée",
        "fleet_member_accepted": "Adhésion acceptée",
        "fleet_request_accepted": "Demande d'adhésion acceptée",
        "fleet_inventory_item_added": "Objet ajouté à l'inventaire de la flotte",
        "fleet_event_published": "Événement publié",
        "fleet_event_locked": "Inscriptions à l'événement verrouillées",
        "fleet_event_starting_soon": "Événement imminent",
        "fleet_event_started": "Événement démarré",
        "fleet_event_completed": "Événement terminé",
        "fleet_event_cancelled": "Événement annulé",
        "fleet_event_signup_added": "Nouvelle inscription",
        "fleet_event_signup_withdrawn": "Inscription retirée",
        "fleet_event_signup_confirmed": "Inscription confirmée",
        "fleet_event_signup_assigned": "Assigné à un poste",
        "fleet_event_signup_kicked": "Retiré d'un poste",
        "allInGroup": "Tout dans ce groupe"
      },
      "fleets": {
        "missions": {
          "title": "Titre",
          "description": "Description",
          "team": "Équipe",
          "teams": "Équipes",
          "ship": "Vaisseau",
          "ships": "Vaisseaux",
          "slot": "Poste",
          "slots": "Postes",
          "noMissions": "Aucune mission pour le moment.",
          "noTeams": "Aucune équipe ajoutée pour le moment.",
          "noShips": "Aucun vaisseau ajouté pour le moment.",
          "noSlots": "Aucun poste ajouté pour le moment.",
          "archivedTab": "Archivées",
          "activeTab": "Actives",
          "archived": "Archivée",
          "modelSpecific": "Vaisseau précis",
          "modelList": "L'un de ceux-ci",
          "modelListHint": "Le poste accepte n'importe lequel des vaisseaux que vous choisissez.",
          "allowedShips": "Vaisseaux compatibles",
          "anyOf": "L'un de",
          "filterRange": "Plage de filtrage",
          "classification": "Classification",
          "focus": "Spécialisation",
          "minSize": "Taille min.",
          "maxSize": "Taille max.",
          "minCrew": "Équipage min.",
          "minCrewOverride": "Remplacer",
          "minCrewOverrideLabel": "Remplacement de l'équipage min.",
          "minCrewOverrideHint": "Laissez vide pour utiliser l'équipage minimum par défaut du vaisseau.",
          "minCargo": "Cargaison min. (SCU)",
          "shipFilters": "Filtres de vaisseaux",
          "createdBy": "Créée par",
          "seats": "Sièges",
          "category": "Catégorie",
          "coverImage": "Image de couverture",
          "coverPresets": "Choisir parmi les exemples",
          "scenario": "Scénario",
          "categories": {
            "other": "Autre",
            "ship_combat": "Combat spatial",
            "ground_combat": "Combat au sol",
            "combined_combat": "Combat combiné",
            "mining": "Minage",
            "salvage": "Récupération",
            "cargo_hauling": "Transport de cargaison",
            "exploration": "Exploration"
          }
        },
        "events": {
          "title": "Titre",
          "description": "Description",
          "briefing": "Briefing",
          "startsAt": "Commence le",
          "endsAt": "Se termine le",
          "timezone": "Fuseau horaire",
          "location": "Lieu de l'événement",
          "meetupLocation": "Lieu de rendez-vous",
          "visibility": "Visibilité",
          "maxAttendees": "Participants max.",
          "maxAttendeesValue": "%{count} participants max.",
          "autoLockEnabled": "Verrouillage automatique des inscriptions",
          "autoLockMinutesBefore": "Minutes avant le début pour verrouiller",
          "recurring": "Répétition",
          "recurringHint": "Générer automatiquement cet événement selon une périodicité. Les membres s'inscrivent à chaque occurrence.",
          "recurringSummary": "Se répète %{interval}",
          "recurringUntil": "Se répète %{interval} jusqu'au %{date}",
          "recurringForCount": "Se répète %{interval} (%{count} occurrences)",
          "viewSeries": "Voir la série",
          "recurrenceInterval": "Répéter tous les",
          "recurrenceEnd": "Fin",
          "recurrenceEndNever": "Jamais",
          "recurrenceEndOn": "À une date",
          "recurrenceEndAfter": "Après",
          "recurrenceEndOccurrences": "occurrences",
          "recurrence": {
            "daily": "tous les jours",
            "weekly": "toutes les semaines",
            "biweekly": "toutes les deux semaines",
            "monthly": "tous les mois"
          },
          "occurrencesSection": "Prochaines occurrences",
          "skipOccurrence": "Ignorer cette occurrence",
          "overrideOccurrence": "Personnaliser l'occurrence du %{date}",
          "overrideOccurrenceShort": "Modifier celle-ci",
          "overrideOccurrenceHint": "Personnalisez des champs pour cette seule occurrence. Laissez vide pour hériter de l'événement récurrent.",
          "endSeriesHere": "Arrêter ici et pour la suite",
          "excludedBadge": "Ignorée",
          "noUpcomingOccurrences": "Aucune occurrence à venir dans les 12 prochaines semaines.",
          "endSeriesConfirm": "Arrêter la répétition après cette date ? Les occurrences futures ne seront pas générées.",
          "skipOccurrenceSuccess": "Occurrence ignorée.",
          "endSeriesSuccess": "Série arrêtée à partir de cette date.",
          "cancelledReason": "Motif d'annulation",
          "noEvents": "Aucun événement pour le moment.",
          "noUpcoming": "Aucun événement à venir.",
          "noPast": "Aucun événement passé.",
          "createdBy": "Créé par",
          "signups": "Inscriptions",
          "signupsCount": "%{count} inscriptions",
          "signupYou": "Vous",
          "youAreHere": "Vous êtes ici",
          "attendance": "Participation",
          "signupsLockedHint": "Les inscriptions sont verrouillées pour cet événement.",
          "noOverview": "Aucune description ni briefing pour le moment.",
          "alreadySignedUpHint": "Vous êtes déjà inscrit à un autre poste. Désinscrivez-vous d'abord pour en changer.",
          "slotTakenHint": "Ce poste est déjà pris.",
          "currentSlot": "Poste actuel",
          "currentSlotHint": "Il s'agit du poste où se trouve actuellement l'inscription.",
          "takenBy": "Pris par %{username}",
          "slotPickerHint": "Choisissez un poste pour cette inscription. Les postes déjà pris ou indisponibles sont désactivés.",
          "signupCtaHint": "Inscrivez-vous à l'événement — vous pouvez choisir un poste précis maintenant ou laisser un administrateur vous en attribuer un plus tard.",
          "noSlotYet": "Pas encore de poste",
          "signupApproval": "Validation des inscriptions",
          "signupApprovalInherit": "Hériter de l'événement",
          "signupStatuses": {
            "confirmed": "Confirmée",
            "tentative": "Provisoire",
            "interested": "Intéressé",
            "pending": "En attente de validation",
            "withdrawn": "Retirée"
          },
          "signupApprovals": {
            "direct": "Directe",
            "confirmation_required": "Confirmation requise"
          },
          "unassignedSignupsHint": "Ces membres se sont inscrits à l'événement mais n'ont pas encore de poste. Attribuez-leur un poste ci-dessous ou retirez l'inscription.",
          "taken": "Pris",
          "grantedRoles": "Rôles attribués",
          "noEventAdminsYet": "Aucun administrateur ni modérateur supplémentaire pour le moment.",
          "creator": "Créateur de l'événement",
          "eventTeamHint": "Accordez à d'autres membres des droits d'administrateur ou de modérateur pour cet événement. Les administrateurs peuvent le modifier, les modérateurs peuvent gérer les inscriptions.",
          "eventRole": "Rôle",
          "eventRoles": {
            "admin": "Administrateur",
            "moderator": "Modérateur"
          },
          "memberPicker": "Membre",
          "spawnedFromMission": "Créé depuis la mission",
          "spawnedEvents": "Événements créés",
          "fromMission": "Depuis la mission",
          "pickTemplate": "Choisir un modèle",
          "pickTemplateHint": "Vous pouvez partir d'un modèle de mission — les champs seront pré-remplis et l'événement y sera rattaché.",
          "noTemplate": "Aucun modèle",
          "noTemplateHint": "Créer l'événement de zéro.",
          "changeTemplate": "Changer de modèle",
          "clearTemplate": "Retirer le modèle",
          "freeSlot": "Poste libre",
          "myVehicle": "Mon véhicule",
          "selectVehicle": "Sélectionner un véhicule (facultatif)",
          "vehicleMismatchHint": "Le véhicule sélectionné ne correspond pas aux exigences de ce poste.",
          "noFittingInHangar": "Rien dans votre hangar ne convient à ce poste. Vous pouvez tout de même vous inscrire en laissant le véhicule vide.",
          "vehicleFitsHint": "Apporte un véhicule qui convient à ce vaisseau.",
          "noMatchingVehicle": "Aucune inscription n'apporte de véhicule adapté.",
          "shipNotCrewedYet": "Aucune inscription adaptée pour le moment.",
          "expandHint": "%{model} dispose de %{count} siège(s) supplémentaire(s). Ajouter des postes pour que d'autres puissent les occuper ?",
          "notes": "Notes",
          "upcomingTab": "À venir",
          "pastTab": "Passés",
          "archivedTab": "Archivés",
          "listTab": "Liste",
          "calendarTab": "Calendrier",
          "openInCalendar": "S'abonner (.ics)",
          "openInCalendarHint": "Ajoutez cette URL à votre application de calendrier pour garder les événements synchronisés.",
          "rotateFeedToken": "Renouveler le lien du flux",
          "subscribeHint": "Copie l'URL du flux de calendrier dans votre presse-papiers afin que vous puissiez la coller dans votre application de calendrier.",
          "visibilities": {
            "members": "Membres",
            "officers": "Officiers",
            "fleet": "Public"
          },
          "statuses": {
            "draft": "Brouillon",
            "open": "Inscriptions ouvertes",
            "locked": "Inscriptions verrouillées",
            "active": "En direct",
            "completed": "Terminé",
            "cancelled": "Annulé",
            "past": "Passé"
          },
          "tabs": {
            "basic": "Informations de base",
            "description": "Description et couverture",
            "teams": "Équipes et vaisseaux",
            "overview": "Aperçu",
            "settings": "Paramètres"
          },
          "calendar": {
            "month": "Mois",
            "week": "Semaine",
            "weekTitle": "Semaine du %{date}"
          },
          "repeats": "Répétition"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "notifications": {
        "inbox": "Boîte de réception",
        "archive": "Archives",
        "unreadOnly": "Non lues uniquement",
        "status": "Statut",
        "type": "Type",
        "selectPrompt": "Sélectionnez une notification pour la lire",
        "noBody": "Cette notification ne contient aucun détail supplémentaire.",
        "archivesOn": "Passe aux archives",
        "deletesOn": "Supprimée"
      },
      "unlistedModel": {
        "linkHint": "Quel vaisseau du catalogue est %{identifier} ? La suggestion vient de l'export et peut être fausse."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Source",
        "sources": {
          "vehicle": "Vaisseau",
          "handMade": "Créé manuellement"
        }
      },
      "inventoryItems": {
        "name": "Nom",
        "category": "Catégorie",
        "entryType": "Mouvement",
        "quantity": "Quantité",
        "quality": "Qualité",
        "notes": "Notes",
        "itemType": "Catalogue",
        "categories": {
          "commodity": "Marchandise",
          "component": "Composant",
          "weapon": "Arme",
          "equipment": "Équipement",
          "ammunition": "Munitions",
          "consumable": "Consommable",
          "other": "Autre"
        },
        "entryTypes": {
          "deposit": "Dépôt",
          "withdrawal": "Retrait"
        },
        "units": {
          "scu": "SCU",
          "units": "unités"
        }
      },
      "scDataSource": {
        "dataSource": "Source des données",
        "notLive": "Pas la version live"
      },
      "erkul": {
        "prefix": "Essayer la configuration avec",
        "link": "Calculatrice de DPS d'Erkul"
      },
      "pagination": {
        "perPage": "Par Page",
        "pages": "%{page} sur %{total}"
      }
    }
  }
}
